(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["country-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = () => {
      const dialog = document.getElementById('sc-country-dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      const current = location.hostname === 'cr.sunchildclub.com' ? 'CR' : 'GT';
      const remember = (country) => {
        document.cookie = 'sc_country=' + country + '; Max-Age=2592000; Path=/; Domain=sunchildclub.com; SameSite=Lax; Secure';
        try { sessionStorage.setItem('sc_country', country); } catch (_) {}
      };
      const open = () => { if (!dialog.open) dialog.showModal(); };
      document.querySelectorAll('[data-sc-country-open]').forEach(button => button.addEventListener('click', open));
      dialog.querySelectorAll('[data-sc-country]').forEach(link => link.addEventListener('click', () => remember(link.dataset.scCountry)));
      dialog.querySelector('[data-sc-country-close]').addEventListener('click', () => { remember(current); dialog.close(); });
      dialog.addEventListener('cancel', () => remember(current));
      let selected = /(?:^|; )sc_country=(GT|CR)(?:;|$)/.test(document.cookie);
      try { selected = selected || Boolean(sessionStorage.getItem('sc_country')); } catch (_) {}
      if (!selected && dialog.dataset.designMode !== 'true') open();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
  })();
  } catch(e) { console.error(e); }
})();

})();
